import axios from 'axios';
import { getToken } from './authService';

const API_BASE = process.env.REACT_APP_API_BASE_URL || '/api';
const client = axios.create({ baseURL: API_BASE });
client.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export async function listUsers() {
  const { data } = await client.get('/users');
  return data; // { users, roles }
}
export async function createUser(payload) {
  const { data } = await client.post('/users', payload);
  return data.user;
}
export async function updateUser(id, payload) {
  const { data } = await client.patch(`/users/${id}`, payload);
  return data.user;
}
export async function deleteUser(id) {
  await client.delete(`/users/${id}`);
}
